import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { dpConfig } from 'src/config';

type ErrorSectionProps = {
  code?: number;
  title: string;
  description: string;
  action: ReactElement;
};

export function ErrorSection({
  code,
  title,
  description,
  action,
}: ErrorSectionProps): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <div className='m-auto text-center'>
      {code && (
        <p className='text-base font-semibold text-primary-default'>{code}</p>
      )}
      <h1 className='mt-4 text-3xl font-bold tracking-tight text-layout-foreground sm:text-5xl'>
        {title}
      </h1>
      <p className='mt-6 text-base leading-7 text-layout-foreground-secondary'>
        {description}
      </p>
      <div className='mt-10 flex items-center justify-center gap-x-6'>
        {action}
        <a
          target='_blank'
          href={dpConfig.support}
          className='text-sm font-semibold text-layout-foreground'
          rel='noreferrer'
        >
          {t('Contact support')} <span aria-hidden='true'>&rarr;</span>
        </a>
      </div>
    </div>
  );
}
